import _ from "lodash";

export function erLikIgnorerCasing(a: string, b: string): boolean {
    if (a === b) return true;
    if (_.isNil(a) || _.isNil(b)) return false; //enten a eller b er null/undefined, men ikke begge
    return a.toLowerCase() == b.toLowerCase();
}

export function trimTilNull(streng: string): string {
    if (_.isNil(streng)) return null;
    streng = streng.trim();
    if (_.isEmpty(streng)) return null;
    return streng;
}

export function erTomEllerNil(streng: string | null): boolean {
    if (_.isNil(streng)) return true;
    streng = streng.trim();
    if (_.isEmpty(streng)) return true;
    return false;
}

export function erIkkeTomStreng(streng: string | null): boolean {
   return !erTomEllerNil(streng);
}

const htmlTagRegexp = /<[^>]+>/gm;

export function fjernHtml(html:string){
    if (html == null) return html;
    return html.replace(htmlTagRegexp, '');
}
